const formatDate = (date) => {
  if (!date) return null
  if (typeof date === 'object') {
    date = date.toISOString()
  }
  const [year, month, day] = date.split('T')[0].split('-')
  return `${month}/${day}/${year}`
}

export default formatDate
